export const getEnrichmentPayload = (
  searchType: string,
  text: string,
  customParams?: any,
  geneFilterType: 'symbol' | 'ensemblId' | 'geneId' | 'uniprotId' | 'name' = 'symbol',
) => {
  const lines = String(text || '')
    .split('\n')
    .map(l => l.trim())
    .filter(Boolean);

  const defaultParams = {
    commonVariants: 2,
    commonGenes: 2,
    maxPvalue: 0.1,
    maxScore: 1,
    minScore: 0.1,
    pageNumber: 0,
    source: 'ALL',
  };

  const params = { ...defaultParams, ...(customParams || {}) };

  if (searchType === 'GENES') {
    const payload = {
      commonGenes: params.commonGenes ?? params.commonVariants ?? 2,
      geneENSEMBLList: '',
      geneNCBIList: '',
      geneHGNCList: '',
      geneUniProtList: '',
      maxPvalue: params.maxPvalue,
      maxScore: params.maxScore,
      minScore: params.minScore,
      pageNumber: params.pageNumber,
      source: params.source,
    };

    const joined = lines.join(',');

    if (geneFilterType === 'symbol' || geneFilterType === 'name') {
      payload.geneHGNCList = joined;
    } else if (geneFilterType === 'ensemblId') {
      payload.geneENSEMBLList = joined;
    } else if (geneFilterType === 'geneId') {
      payload.geneNCBIList = joined;
    } else if (geneFilterType === 'uniprotId') {
      payload.geneUniProtList = joined;
    }

    return payload;
  }

  if (searchType === 'VARIANTS') {
    return {
      commonVariants: params.commonVariants ?? 2,
      variantList: lines.join(','),
      maxPvalue: params.maxPvalue,
      maxScore: params.maxScore,
      minScore: params.minScore,
      pageNumber: params.pageNumber,
      source: params.source,
    };
  }

  return params;
};

export const getGseaPayload = (
  text: string,
  customParams?: Record<string, unknown>,
  geneFilterType: 'symbol' | 'ensemblId' | 'geneId' | 'uniprotId' | 'name' = 'symbol',
) => {
  const lines = String(text || '')
    .split('\n')
    .map(l => l.trim())
    .filter(Boolean);

  const defaultParams = {
    source: 'ALL',
    minScore: 0,
    maxScore: 1,
    exponent: 1,
    minCommonGenes: 2,
    minGeneSetSize: 15,
    maxGeneSetSize: 500,
    minHits: 1,
    nPermutations: 1000,
  };

  const params = { ...defaultParams, ...(customParams || {}) };

  const payload: Record<string, string | number> = {
    geneENSEMBLList: '',
    geneNCBIList: '',
    geneHGNCList: '',
    geneUniProtList: '',
    source: String(params.source),
    minScore: Number(params.minScore),
    maxScore: Number(params.maxScore),
    exponent: Number(params.exponent),
    minCommonGenes: Number(params.minCommonGenes),
    minGeneSetSize: Number(params.minGeneSetSize),
    maxGeneSetSize: Number(params.maxGeneSetSize),
    minHits: Number(params.minHits),
    nPermutations: Number(params.nPermutations),
  };

  const joined = lines.join(',');

  if (geneFilterType === 'symbol' || geneFilterType === 'name') {
    payload.geneHGNCList = joined;
  } else if (geneFilterType === 'ensemblId') {
    payload.geneENSEMBLList = joined;
  } else if (geneFilterType === 'geneId') {
    payload.geneNCBIList = joined;
  } else if (geneFilterType === 'uniprotId') {
    payload.geneUniProtList = joined;
  }

  return payload;
};

export function createGseaInfoContent({
  text,
  gseaParams,
  geneFilterType,
}: {
  text: string;
  gseaParams: Record<string, unknown>;
  geneFilterType: string;
}) {
  return `GSEA ANALYSIS INFORMATION
=========================

Download Date:   ${new Date().toLocaleString()}

QUERY
-----
Query Text:      ${text}

PARAMETERS
----------
Filter Type:     ${geneFilterType.replace('geneSymbol', 'symbol')}
GSEA Params:     ${JSON.stringify(gseaParams, null, 2)}

========================`;
}

export function createEnrichmentInfoContent({ searchType, text, enrichmentParams, geneFilterType }) {
  return `ENRICHMENT INFORMATION
========================

Download Date:   ${new Date().toLocaleString()}

QUERY
-----
Search Type:     ${searchType}
Query Text:      ${text}

PARAMETERS
----------
Filter Type:     ${searchType === 'GENES' ? (geneFilterType === 'name' ? 'symbol' : geneFilterType.replace('geneSymbol', 'symbol')) : 'strID'}
Custom Params:   ${JSON.stringify(enrichmentParams, null, 2)}

========================`;
}
